<form [formGroup]="formGroup" class="w-100">
	<div class="flex-column gap-32">
		<app-card inCardTitle="Inspection Form Detail"
				  icon="arrow_back"
				  [iconDisabled]="saving"
				  (iconClicked)="navigateBack()">
			<div *appCardContentRaw>
				@if (saveError) {
					<mat-error>{{ saveError }}</mat-error>
				}
				@if (loading) {
					<mat-spinner class="my-16 mx-a" [diameter]="32"></mat-spinner>
				} @else if (loadError) {
					<div class="load-error m-8">
						<mat-error>{{ loadError }}</mat-error>
					</div>
				} @else {
					<div class="field-row p-16 m-0">
						<div class="field-row-title">Form Title</div>
						<div class="field-row-element">
							<mat-form-field subscriptSizing="dynamic"
											class="w-100">
								<input matInput
									   appSetFocusOnLoad
									   required
									   formControlName="title">
								@if (formGroup.controls.title.hasError('required')) {
									<mat-error>
										Form title is required
									</mat-error>
								}
							</mat-form-field>
						</div>
					</div>

					<mat-divider></mat-divider>
					<div class="p-16">
						<app-row-with-select
								primaryText="Question format"
								secondaryText="Present one or multiple questions at a time"
								listLabel="label"
								[list]="DvirFormQuestionFormatOption.options"
								formControlName="questionFormat">
						</app-row-with-select>
					</div>
					<mat-divider></mat-divider>
					<div class="p-16">
						<div class="field-row align-items-center m-0">
							<div class="field-row-title">
								<div>Manage form questions</div>
								<div class="whitespace-no-wrap">Add or remove inspection questions</div>
							</div>
							<div class="field-row-element">
								<button mat-stroked-button
										type="button"
										[disabled]="saving || formGroup.invalid"
										(click)="editQuestions()">
									Manage Questions
								</button>
							</div>
						</div>
					</div>
					<mat-divider></mat-divider>
					<div class="p-16">
						<app-row-with-toggle
								primaryText="Include input box for additional remarks at the end of the form"
								formControlName="hasRemarks">
						</app-row-with-toggle>
					</div>
					<mat-divider></mat-divider>
					<div class="p-16">
						<app-row-with-toggle primaryText="Additional Signatures"
											 secondaryText="Decide who has to sign the inspection forms"
											 formControlName="requireSignatures">
						</app-row-with-toggle>
						@if (formGroup.controls.requireSignatures.value) {
							<div class="mt-8">
								<mat-radio-group
										class="form-radio-group"
										formControlName="reviewingSignatures">
									@for (
                                        option of DvirFormReviewingSignaturesOption.signatureOptions; track option.code) {
										<mat-radio-button class="form-radio-button" [value]="option">
											<div class="indent my-8">
												<div>
													{{ option.label }}
												</div>
												<div class="secondary">
													{{ option.description }}
												</div>
											</div>
										</mat-radio-button>
										@if (!$last) {
											<mat-divider></mat-divider>
										}
									}
								</mat-radio-group>
							</div>
						}

					</div>
					<mat-divider></mat-divider>
					<div class="p-16">
						<app-row-with-toggle primaryText="Notifications"
											 secondaryText="Get email notification for completed inspections forms"
											 formControlName="enableEmailNotifications">
						</app-row-with-toggle>

						@if (formGroup.value['enableEmailNotifications']) {
							<div class="mt-8">
								<mat-radio-group
										class="form-radio-group mt-8"
										formControlName="emailNotificationType">
									@for (type of dvirFormEmailNotificationTypes; track $index) {
										<mat-radio-button class="form-radio-button" [value]="type.value">
											<div class="indent my-8">
												<div>{{ type.label }}
												</div>
												<div class="secondary">{{ type.description }}</div>
											</div>
										</mat-radio-button>
										@if (!$last) {
											<mat-divider></mat-divider>
										}
									}
								</mat-radio-group>
							</div>

							@if (notificationUsers) {
								<div class="form-radio-button py-16">
									<div>
										Recipients:
									</div>
									@if (notificationUsers?.length > 0) {
										<div class="mt-8">
											@for (user of notificationUsers; track user.email) {
												<div>
													<mat-checkbox [checked]="user.selected"
																  (change)="notificationUsersChanged(user, $event)">
														{{ user.email }}
													</mat-checkbox>
												</div>
											}
										</div>
									}
									@if (formGroup.hasError('missingRecipient')) {
										<mat-error class="mt-8">
											Choose at least one recipient.
										</mat-error>
									}
								</div>
							}
						}
					</div>
				}
			</div>
		</app-card>
	</div>
</form>
